import { useEffect } from "react";
import { authClient } from "../oidcClientFront";
import { getCurrentUser, logout } from "../authService";

const logoutUrl = "http://localhost:3090/auth/logout";
// const logoutUrl = "/";

const Logout = () => {
  useEffect(() => {
    // const checkUser = async () => {
    //   const user = await getCurrentUser();
    //   if (user || (user && !user.expired)) {
    //     // authClient.removeUser();
    //     logout();
    //   } else {
    //     window.location.href = logoutUrl;
    //   }
    // };
    // checkUser();
    logout();
  }, []);

  return <div>Signing out...</div>;
};

export default Logout;
